import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/forgot-password", {
        identifier: identifier.trim(),
      });
      setMessage(
        data?.message ||
          "If an account exists, a reset link has been sent."
      );
      toast.success("Request received.");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      eyebrow="Recovery"
      title="Reset your password."
      subtitle="Enter the email or phone number associated with your account. This is a stub — in production a reset link will be emailed / SMSed to you."
    >
      <form
        data-testid="forgot-form"
        onSubmit={onSubmit}
        className="flex flex-col gap-6"
        noValidate
      >
        <div>
          <label className="block text-sm font-medium text-slate-900 mb-2" htmlFor="identifier">
            Email or phone number
          </label>
          <input
            data-testid="forgot-identifier-input"
            id="identifier"
            required
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="you@company.com or +14155550101"
            className="w-full h-12 px-4 rounded-sm bg-slate-50 border border-slate-200 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] transition-colors"
          />
        </div>

        {error && (
          <div
            data-testid="forgot-error"
            role="alert"
            className="text-sm text-[#D92D20] border border-[#D92D20]/30 bg-[#D92D20]/5 px-3 py-2 rounded-sm"
          >
            {error}
          </div>
        )}
        {message && (
          <div
            data-testid="forgot-message"
            className="text-sm text-[#039855] border border-[#039855]/30 bg-[#039855]/5 px-3 py-2 rounded-sm"
          >
            {message}
          </div>
        )}

        <button
          data-testid="forgot-submit-button"
          type="submit"
          disabled={submitting}
          className="h-12 w-full bg-[#002FA7] text-white font-medium rounded-sm hover:bg-[#002280] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {submitting ? "Sending…" : "Send reset link"}
        </button>

        <p className="text-sm text-slate-600">
          Remembered it?{" "}
          <Link
            data-testid="forgot-goto-login-link"
            to="/login"
            className="text-[#002FA7] font-medium hover:underline"
          >
            Back to sign in
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
}
